<template>
    <!-- Ionic modal provides --max-height -->
    <div class="pt-4 pb-(--beyond-safe-area-inset-bottom) h-(--max-height) flex flex-col">
        <IonHeader
            class="ion-no-border"
            data-cy="filters-modal"
        >
            <ModalHeader @close="onCancelled">
                Calendar
            </ModalHeader>
        </IonHeader>
        <IonContent>
            <DForm class="p-4">
                <div class="py-3 pt-0">
                    <DField>
                        <DRadio
                            v-for="(calendar, index) in calendars"
                            :key="`calendar-${calendar.type}-${calendar.id || 'x'}`"
                            v-model="selectedIndex"
                            card
                            :native-value="index"
                            radio-position="right"
                        >
                            <template #icon>
                                <UIAvatar
                                    v-if="calendar.avatar"
                                    :avatar="calendar.avatar"
                                    size-override="medium-small"
                                />
                                <DAvatar
                                    v-else-if="calendar.icon"
                                    type="icon"
                                    :icon="`ph:${calendar.icon.icon}`"
                                    size="10"
                                />
                            </template>
                            {{ calendar.title }}
                        </DRadio>
                    </DField>
                </div>
            </DForm>
        </IonContent>
    </div>
</template>
<script setup>
    import {
        DAvatar, DForm, DField, DRadio,
    } from '@digistorm/spark'
    import { findIndex } from 'lodash'
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const props = defineProps({
        calendars: Array,
        onSelected: Function,
        onCancelled: Function,
    })

    const selectedIndex = ref(findIndex(props.calendars, { active: true }) || 0)

    watch(() => selectedIndex.value, (index) => {
        props.onSelected(props.calendars[index])
    })
</script>
